/** Main project script */
'use strict';


import {createApp} from 'vue';
import {Carousel, Collapse, Lightbox, Tab, initTE} from "tw-elements";
import GalleryCarousel from './components/gallery-carousel';
import CardCarousel from './components/card-carousel';
import SuggestiveSearch from './components/suggestive-search';
import MapBox from './components/map-box';


// import Gallery from "./components/gallery";
// import InFocus from './components/in-focus';
// import OpenStreetMap from "./components/open-street-map";

// import "leaflet/dist/leaflet.css";

// import {debounce} from 'lodash';
// Vue.config.productionTip = false;
// Vue.config.devtools = false;


import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql


const app = createApp({
    components: {
        GalleryCarousel,
        CardCarousel,
        SuggestiveSearch,
        MapBox
    },
    // Shared app state
    data() {
        return {
            menuScrollReveal: 170,
            navigation: {
                open: false,
                openSubMenu: 0,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                searchBarOpen: false,
                searchResults: false,
            },
            minPageHeight: null,
            scrolled: false,
            modal: 0
        };
    },
    watch: {
        'navigation.searchBarOpen': function (val) {
            document.body.classList.remove('custom-overflow-y-hidden');
            document.body.classList.remove('custom-h-screen');
            if (val) {
                document.body.classList.add('custom-overflow-y-hidden');
                document.body.classList.add('custom-h-screen');
            }
        },
        'navigation.mobileMenuOpen': function (val) {
            document.body.classList.remove('custom-overflow-y-hidden');
            document.body.classList.remove('custom-h-screen');
            if (val) {
                document.body.classList.add('custom-overflow-y-hidden');
                document.body.classList.add('custom-h-screen');
            }
        },
        'modal': function (val) {
            document.body.classList.remove('custom-overflow-y-hidden');
            document.body.classList.remove('custom-h-screen');
            if (val) {
                document.body.classList.add('custom-overflow-y-hidden');
                document.body.classList.add('custom-h-screen');
            }
        },
    },
    computed: {
        showGreenBar: function () {
            if (this.navigation.mobileMenuOpen || this.navigation.searchBarOpen) {
                return false;
            }
            return this.scrolled
        },
        showLogo: function () {
            if (this.navigation.mobileMenuOpen || this.navigation.searchBarOpen) {
                return true;
            }
            return this.scrolled
        },
        console: () => console,
        window: () => window,
    },
    methods: {
        handleSearchResultsStatus(hasResults) {
            // Do something with hasResults
            this.navigation.searchResults = hasResults;
        },
        handleScroll: function () {
            if (this.navigation.mobileMenuOpen || this.navigation.searchBarOpen) {
                return false;
            }
            if (window.scrollY > this.menuScrollReveal) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        toggleSubmenu: function (id) {

            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                this.navigation.mobileMenuOpen = true;
            } else {
                this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.searchBarOpen = false;
            this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen;
        },
        toggleMobileSubmenu: function (id) {
            if (this.navigation.mobileMenuSubMenu === id) {
                this.navigation.mobileMenuSubMenu = 0;
            } else {
                this.navigation.mobileMenuSubMenu = id;
            }
        },
        videoLightbox: function (fragment) {
            // run

        },
        goTo: function (url) {
            window.location.href = url;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[0].dataset?.presetClass?.trim().split(' ');
                let parent = targets[0].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));
        },
        scrollHelper: function (el, elClass, offset, callback) {
        },
        setupColumnTabs: function () {
            const columnTabs = document.querySelectorAll('.element-column-tabs');
            columnTabs.forEach(tab => {
                const tabCont = tab.querySelector('.tab-container');
                const tabIndicator = tab.querySelector('.tab-indicator');
                const entireCont = tabCont.parentElement;

                // Set static height for tab container
                entireCont.style.height = entireCont.offsetHeight + 'px';
                let currentHeight = entireCont.offsetHeight;

                const tabEls = tab.querySelectorAll('.tab-nav');
                tabEls.forEach(element => {
                    element.addEventListener('shown.te.tab', (e) => {
                        tabIndicator.style.top = element.offsetTop + 'px';
                        tabIndicator.style.height = element.offsetHeight + 'px';

                        // Animate
                        entireCont.classList.remove('transition-all', 'ease-linear', 'duration-150');
                        entireCont.style.height = 'auto';

                        const newHeight = entireCont.offsetHeight;
                        entireCont.style.height = currentHeight + 'px';

                        // Force a reflow
                        void entireCont.offsetHeight;

                        entireCont.classList.add('transition-all', 'ease-linear', 'duration-150');
                        entireCont.style.height = newHeight + 'px';

                        currentHeight = newHeight;
                    });
                });
            });
        },
        setupCardTabs: function () {
            const cardTabs = document.querySelectorAll('.element-card-tabs');

            cardTabs.forEach(tab => {
                const tabEls = tab.querySelectorAll('.tab-nav');
                const activeTab = tab.querySelector('.tab-nav.selected-card');
                const inactiveTab = tab.querySelector('.tab-nav:not(.selected-card)');

                const maxWidth = activeTab.offsetWidth;
                const minWidth = inactiveTab.offsetWidth;

                tabEls.forEach(element => {
                    element.style.width = element.offsetWidth + 'px';

                    element.addEventListener('shown.te.tab', (e) => {
                        tabEls.forEach(el => {
                            el.classList.remove('selected-card');
                            el.classList.remove('after:bg-petrol');
                            el.style.backgroundImage = '';
                            el.style.width = minWidth + 'px';
                        });

                        const parent = e.target.parentElement;

                        parent.classList.add('selected-card');
                        if (parent.dataset.image !== undefined) {
                            parent.classList.add('after:bg-petrol');
                        }
                        parent.style.backgroundImage = `url(${parent.dataset.image})`;
                        parent.style.width = maxWidth + 'px';
                    });
                });
            });
        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },
        setupLazyLoad: function () {
            document.addEventListener("DOMContentLoaded", function () {
                var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

                if ("IntersectionObserver" in window) {
                    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                entry.target.classList.add("lazy-visible");
                                lazyBackgroundObserver.unobserve(entry.target);
                            }
                        });
                    });

                    lazyBackgrounds.forEach(function (lazyBackground) {
                        lazyBackgroundObserver.observe(lazyBackground);
                    });
                }
            });

        }
    },
    created() {
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);

    },
    mounted() {
        initTE({Carousel, Collapse, Lightbox, Tab});
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
        this.setupScrollHelper();
        this.setupColumnTabs();
        this.setupCardTabs();
        this.setupLazyLoad();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');
